module.exports = __webpack_public_path__ + "static/media/mtv-logo.96e79253.svg";